export default "__VITE_ASSET__BIP_aufz__"